import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ScreenLoader from '../../../components/ScreenLoader';
import actions from '../../../redux/actions';
import NavbarSidebarWrapper from '../../../components/navbarSidebarWrapper';
import TableWrapper from './TableWrapper';
import TableNumData from './TableNumData';
import { useParams } from 'react-router-dom';

const SMBookedGame = () => {
  const { MarketId, MarketName } = useParams();
  let betsOfUserResult = useSelector((state) => state.SM.SMBetsOfUser?.Result);
  let getSMBookResult = useSelector((state) => state.SM.SMBookData?.Result);
  let userlist = useSelector((state) => state.auth.userDataList?.Result);

  const [loader, setLoader] = useState(true);
  const [data, setData] = useState({ type: 0 });
  const [userInput, setUserInput] = useState('');
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [userId, setUserId] = useState(null);
  const [activeTab, setActiveTab] = useState("tab1");

  const handleData = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleUserInputChange = (e) => {
    const { value } = e.target;
    setUserInput(value);
  };

  const handleOpenMarketList = async () => {
    setLoader(true);
    try {
      await actions.getSMBook(MarketId);
      let res = await actions.GetSMMBetsOfUser(MarketId, '0');

      if (res?.status === 200) {
        setLoader(false);
      } else {
        console.error("Failed to fetch bets data:", res);
        setLoader(false); // Ensure loader is stopped even on failure
      }
    } catch (error) {
      console.error("Error fetching market data:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    handleOpenMarketList();
  }, [MarketId]);


  const handleUserSelection = (user) => {
    setUserId(user.uid);
    setUserInput(user.username);
    setUserSuggestions([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    await actions.GetSMMBetsOfUser(MarketId, userId);
    await actions.getSMBook(MarketId);
    setLoader(false);
    setActiveTab("tab2");
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoader(true);
    setUserId(null);
    setUserInput("");
    await actions.GetSMMBetsOfUser(MarketId, '0');
    setLoader(false);
    setActiveTab("tab1");
  };

  useEffect(() => {
    if (userInput?.trim() !== "") {
      actions.getUserSearchList(userInput);
    }
  }, [userInput]);

  useEffect(() => {
    if (userlist && Array.isArray(userlist)) {
      setUserSuggestions(userlist);
    }
  }, [userlist]);

  const totalBetAmount = Array.isArray(getSMBookResult)
    ? getSMBookResult.reduce((acc, item) => acc + (Number(item?.Amount) || 0), 0)
    : 0;

  return (
    <NavbarSidebarWrapper>
      <div>
        <div className="content-header-btn mb-2">
          <div>
            {MarketName} Game | Total Bet Amount: {Math.abs(totalBetAmount)}
          </div>
        </div>
        {activeTab === "tab2" && <div className="col-md-3 col-sm-3 px-0 pb-3">
          <div className="form-group">
            <label htmlFor="uid">Search User:</label>
            <input
              type="text"
              name="uid"
              value={userInput}
              onChange={handleUserInputChange}
              className="form-control"
            />
            {userSuggestions?.length > 0 && (
              <ul className="suggestion-list">
                {userSuggestions?.map((user, index) => (
                  <li key={index} onClick={() => handleUserSelection(user)}>
                    {user?.username}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="form-actions no-margin-bottom">
            <button
              onClick={handleSubmit}
              className="custom-yellow-btn"
              style={{ fontSize: "12px" }}
            >
              Submit
            </button>
            <button
              onClick={handleReset}
              className="custom-grey-btn"
              style={{ fontSize: "12px" }}
            >
              Reset
            </button>
          </div>
        </div>}
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
              onClick={() => setActiveTab("tab1")}
              style={{ cursor: "pointer" }}
            >
              Number
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
              onClick={() => setActiveTab("tab2")}
              style={{ cursor: "pointer" }}
            >
              List
            </a>
          </li>
        </ul>
        {loader ? (
          <ScreenLoader />
        ) : (
          <div className="tab-content">
            <div className={`tab-pane fade ${activeTab === "tab1" ? "show active" : ""}`} id="tab1">
              <TableNumData data={getSMBookResult} />
            </div>
            <div className={`tab-pane fade ${activeTab === "tab2" ? "show active" : ""}`} id="tab2">
              <TableWrapper data={betsOfUserResult} />
            </div>
          </div>
        )}
      </div>
    </NavbarSidebarWrapper>
  );
};

export default SMBookedGame;
